



































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { required } from '@/utils/validate';
import SmsField from '@/components/form/SmsField.vue';

const Login = namespace('login');

// 短信验证码登录
@Component({
  components: { SmsField },
})
export default class MemberLogin extends Vue {
  @Login.Action('login') public login!: any;
  @Login.State('loading') public loading!: boolean;

  @Prop() public tab!: number;
  @Prop() public visible!: boolean;
  @Ref('form') public formRef!: HTMLFormElement;

  public required = required;
  public formData = { username: '', vailCode: '' };

  public onSubmit() {
    return;
  }

  @Watch('visible')
  public visibleChange(visible: boolean) {
    if (!visible) {
      this.formRef.reset();
    }
  }

  @Watch('tab')
  public tabChange() {
    this.formRef.reset();
  }
}
